import { Pagination as AisPagination, usePagination } from "react-instantsearch";
import React, { useEffect } from "react";
import styled from "styled-components";
import ConditionalDisplay from "../../components/elements/ConditionalDisplay";
import { useSearchPageContext } from "../../components/pages/SearchPage/SearchPageContext";

export default function Pagination(props: any) {
  const { isMobile } = useSearchPageContext();
  const { nbPages, currentRefinement } = usePagination();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentRefinement]);

  return (
    <ConditionalDisplay hidden={nbPages <= 1}>
      <StyledPagination padding={isMobile ? 1 : 2} />
    </ConditionalDisplay>
  );
}

const StyledPagination = styled(AisPagination)`
  display: flex;
  justify-content: center;
  margin: 1rem 0;

  .ais-Pagination-list {
    display: flex;
    list-style: none;
    padding: 0;
  }

  .ais-Pagination-item {
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    &:not(:last-child) {
      border-right: none;
    }
    &:first-child {
      border-top-left-radius: 0.375rem;
      border-bottom-left-radius: 0.375rem;
    }
    &:last-child {
      border-top-right-radius: 0.375rem;
      border-bottom-right-radius: 0.375rem;
    }
    &.ais-Pagination-item--selected {
      background-color: #111;
      .ais-Pagination-link {
        color: #fff;
      }
    }
    &:not(.ais-Pagination-item--selected):not(.ais-Pagination-item--disabled):hover {
      background-color: #f8f8f8;
    }
    &.ais-Pagination-item--disabled {
      user-select: none;
      background-color: #eee;
      border-color: #eee;
      .ais-Pagination-link {
        color: #ccc;
      }
    }
  }
  .ais-Pagination-link {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 1.1em;
    color: #555;
    height: 100%;
    width: 100%;
  }
  .ais-Pagination-item--firstPage,
  .ais-Pagination-item--previousPage,
  .ais-Pagination-item--nextPage,
  .ais-Pagination-item--lastPage {
    .ais-Pagination-link {
      padding-bottom: 5px;
      font-size: 2em;
      letter-spacing: -3px;
      color: #555;
    }
  }
  .
`;
